import { ViewModel,View } from "binder"
import { ServerConnection } from "src/server/serverConnection";
import { IEditorPart } from "../processDefinition-viewModel";
import  { DataModelDesignerView } from "./dataModelDesigner-view"

export class DataModelDesignerViewModel extends ViewModel implements IEditorPart{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.title = 'مدل داده';
    }
    GetDefaultView(): View <ViewModel> {
        return new DataModelDesignerView();
    }
    public getTypeId(): string {
        return "VM-6CBDF757-14D0-4CBE-A0F2-BEC9E7E3EC6D"
    }

    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    private _processId : string;
    async loadByProcessId(processId: string) {
        try {
            this.isLoading = true;
            this._processId = processId;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetCurrentProcessDataModel',{
                ProcessId: processId
            });
            this.content = result.DataModelXml;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async save(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/UpdateProcessDataModel',{
                ProcessId: this._processId,
                DataModelXml : this.content
            });
            this.messageBoxConfirmSuccess("مدل داده ای با موفقیت ذخیره شد",'ذخیره سازی');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}
